/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Body_Measures_ValueInputs */

const en_us2_body_measures_value = /** @type {(inputs: Body_Measures_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} cm`)
};

const pt_br2_body_measures_value = /** @type {(inputs: Body_Measures_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} cm`)
};

const es_419_body_measures_value = /** @type {(inputs: Body_Measures_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} cm`)
};

const pt_pt2_body_measures_value = /** @type {(inputs: Body_Measures_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} cm`)
};

const fr_fr2_body_measures_value = /** @type {(inputs: Body_Measures_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} cm`)
};

const de_de2_body_measures_value = /** @type {(inputs: Body_Measures_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} cm`)
};

const it_it2_body_measures_value = /** @type {(inputs: Body_Measures_ValueInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} cm`)
};

/**
* | output |
* | --- |
* | "{value} cm" |
*
* @param {Body_Measures_ValueInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_value = /** @type {((inputs: Body_Measures_ValueInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_ValueInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_value(inputs)
	if (locale === "es-419") return es_419_body_measures_value(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_value(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_value(inputs)
	if (locale === "de-DE") return de_de2_body_measures_value(inputs)
	if (locale === "it-IT") return it_it2_body_measures_value(inputs)
	return en_us2_body_measures_value(inputs)
});
export { body_measures_value as "body-measures.value" }